import { changeWH } from "./hooks/sprintboard";
import { openTask } from './uiEventHandler';



let dragStartParentClass = null;

let dragStartClassId = null;
let dragEndClassId = null;

//ドラッグ開始
const dragMoveStart = (event) => {
    //ドラッグ開始時のカーソルの位置とドラッグしているタスクの左上の位置の差を出しておく
    const rect = event.target.getBoundingClientRect();
    const distCursorToElemX = event.clientX - rect.left;
    const distCursorToElemY = event.clientY - rect.top;
                
    event.target.setAttribute("distX",distCursorToElemX);
    event.target.setAttribute("distY",distCursorToElemY);
    dragStartParentClass = getParentClass(event);
    if(dragStartParentClass){
        dragStartClassId = dragStartParentClass.getAttribute("id");
    }
    

    //画面の比率変化によるタスクドラッグ開始位置でエラーが出ないようにgetParentClassは使用しないoyanogamennhiritunitaiousaseta
    const target = event.target;
    dragStartClassId = target.parentNode.getAttribute("id");
}

//ドラッグ終了
const dragMoveEnd = (event,updateDataOnTaskMove) => {
    const posValue = isElementInRange(event,dragStartParentClass);
    
    
    const dragEndParentClass = getParentClass(event);
    
    //widthとheightを求めることでleftとtopの比率を取得
    
    
    if(dragEndParentClass){
        dragEndClassId = dragEndParentClass.getAttribute("id");
        const posPercent = positionInPercent(dragEndParentClass,posValue);
        updateDataOnTaskMove(
            dragStartClassId,
            dragEndClassId,
            event.target.getAttribute("data-keyvalue"),
            //posValue.posX,
            //posValue.posY
            posPercent.widthPercent,
            posPercent.heightPercent
        );
    }
                
}
export{ dragMoveStart,dragMoveEnd,taskReSize,resizeObserver,handleItemClick };



//親に対しての子のタスクの座標の比率を取得する
function positionInPercent(parent,childPos){
    const parentWidth = parent.getBoundingClientRect().width;
    const parentHeight = parent.getBoundingClientRect().height;


    const widthPercent = (childPos.posX / parentWidth) * 100;
    const heightPercent = (childPos.posY / parentHeight) * 100;

    return{
        widthPercent:widthPercent,
        heightPercent:heightPercent
    }

}

//タスクの四つ角の位置を調べて同じ要素(class = gridを持つ)内だったらそれを返す。親グリッドを見つける
function getParentClass(event){
    let posX = event.clientX - event.target.getAttribute("distX");
    let posY = event.clientY - event.target.getAttribute("distY");
    const elemRect = event.target.getBoundingClientRect();
    const underTopLeft = document.elementsFromPoint(posX,posY);
    const underButtomLeft = document.elementsFromPoint(posX,posY + elemRect.height);
    const underButtomRight = document.elementsFromPoint(posX + elemRect.width,posY);

    const underTopLeftClass = underTopLeft.filter(element => {
        return element.classList.contains('grid');
    });

    const underButtomLeftClass = underButtomLeft.filter(element => {
        return element.classList.contains('grid');
    });

    const underButtomRightClass = underButtomRight.filter(element => {
        return element.classList.contains('grid');
    });

    if(underTopLeftClass && underButtomLeftClass && underButtomRightClass){
        if(underTopLeftClass[0] === underButtomLeftClass[0] && underButtomLeftClass[0] === underButtomRightClass[0]){
            return underTopLeftClass[0];
        }
    }

    const gridElement = event.target;
    const elementsUnderCursor = document.elementsFromPoint(
        event.clientX - event.target.getAttribute("distX"),
        event.clientY - event.target.getAttribute("distY"),
    );
    const elemsClass = elementsUnderCursor.filter(element => {
        return element.classList.contains('grid');
    });
    if(elemsClass[0]){
        //return elemsClass[0].getAttribute("id");
        //return elemsClass[0];
    }
    
}

function isElementInRange(event,dragStartParentClass){
    let posX = event.clientX - event.target.getAttribute("distX");
    let posY = event.clientY - event.target.getAttribute("distY");

    const elementsUnderCursor = document.elementsFromPoint(
        event.clientX,
        event.clientY
    );
    
    const elemsClass = elementsUnderCursor.filter(element => {
        return element.classList.contains('grid');
    });
    if(elemsClass[0]){
        
        const dragEndParentRect = elemsClass[0].getBoundingClientRect();
        //マウスの位置から，親要素の位置と，エレメントとマウスの位置の差を引く
        //const posX = event.clientX - parentRect.left - event.target.getAttribute("distX");
        //const posY = event.clientY - parentRect.top - event.target.getAttribute("distY");


        //ドロップしたエレメントの左上の座標
        const elemPosX = event.clientX - event.target.getAttribute("distX");
        const elemPosY = event.clientY - event.target.getAttribute("distY");
    
        const elemRect = event.target.getBoundingClientRect();

        const underTopLeft = document.elementsFromPoint(elemPosX,elemPosY);
        const underButtomLeft = document.elementsFromPoint(elemPosX,elemPosY + elemRect.height);
        const underButtomRight = document.elementsFromPoint(elemPosX + elemRect.width,elemPosY);

        const underTopLeftClass = underTopLeft.filter(element => {
            return element.classList.contains('grid');
        });

        const underButtomLeftClass = underButtomLeft.filter(element => {
            return element.classList.contains('grid');
        });

        const underButtomRightClass = underButtomRight.filter(element => {
            return element.classList.contains('grid');
        });

        if(underTopLeftClass && underButtomLeftClass && underButtomRightClass){
            if(underTopLeftClass[0] === underButtomLeftClass[0] && underButtomLeftClass[0] === underButtomRightClass[0]){
                posX -= dragEndParentRect.left;
                posY -= dragEndParentRect.top;
                return{
                    posX:posX,
                    posY:posY,
                }
            }
        }
        
    }
    if(dragEndClassId && dragStartParentClass){
        const dragStartParentRect = dragStartParentClass.getBoundingClientRect();
        posX = event.target.getBoundingClientRect().left - dragStartParentRect.left;
        posY = event.target.getBoundingClientRect().top - dragStartParentRect.top;
    }
    
    return{
        posX:posX,
        posY:posY,
    }
    
}


let isResizing = false;
//タスクのリサイズを処理


function taskReSize(event){
    const targetElem = event.target;
    const task = targetElem.parentNode;
    isResizing = true;
}


//タスクのサイズ変更を感知+サイズ変更後にイベントを実行
//setTimeOutを使用してDOMの反映を待ってから実行(初期は遅延が必要、タスクのグリッド移動時は0でも動くけどsetTimeOutがないとバグる)

//反映を待つsetTimeOutと変更終了を決めるsetTimeOutのせいでラグが生まれ、
//実行前にタスクを動かされると意図しない挙動が起こる
let timer = 0;
const delay = 500;
let isResize = false;
const obsElems = new WeakMap();
function resizeObserver(){

    setTimeout(() => {
        const gridItems = document.querySelectorAll(".grid-item");
        gridItems.forEach(gridItem => {
            if(obsElems.has(gridItem)){
                return;
            }
            const resizeobs = new ResizeObserver(entries => {
                clearTimeout(timer);
                isResize = true;
                timer = setTimeout(() => {
                    for(let entry of entries){
                        const{width,height} = entry.contentRect;
                        
                        if(entry.target.parentNode != null ){
                            const parentId = entry.target.parentNode.getAttribute("id");
                            const elemId = entry.target.getAttribute("data-keyvalue");
                            //タスク移動時に微小な変化でResizeObserverが動く
                            changeWH(parentId,elemId,width,height);
                            //isResize = false;
                        }
                        
                        
                    }
                    isResize = false;
                },delay);
            });
            resizeobs.observe(gridItem);
            obsElems.set(gridItem,resizeobs);
        });
    },50);
    
}
//タスクがクリックされたらタスクを表示
//ダブルクリック式に変えたから変えていい###
function handleItemClick(key,value,mapName){
    if(!isResize){        
        openTask(key,value,mapName,"1");
    }
    else{
        isResize = false;
    }
}